import { render, staticRenderFns } from "./LeadsReminder.vue?vue&type=template&id=6e448919&scoped=true"
import script from "./LeadsReminder.vue?vue&type=script&lang=js"
export * from "./LeadsReminder.vue?vue&type=script&lang=js"
import style0 from "./LeadsReminder.vue?vue&type=style&index=0&id=6e448919&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e448919",
  null
  
)

export default component.exports